module.exports = __webpack_public_path__ + "img/i1.6dc54431.png";